import { Action, createReducer, on } from '@ngrx/store';
import {
  clearClinicDetails,
  getClinicDetails,
  getClinicDetailsFailure,
  getClinicDetailsSuccess,
  getClinics,
  getClinicsFailure,
  getClinicsSuccess,
  getSearchAddress,
  updateSearchAddress,
} from './actions';
import { State, initialState } from './state';

export const clinicFeatureKey = 'clinic';

const clinicReducer = createReducer(
  initialState,
  on(clearClinicDetails, (state) => ({
    ...state,
    clinicDetails: null,
  })),

  on(getClinics, (state) => ({
    ...state,
    clinicsLoading: true,
  })),
  on(getClinicsSuccess, (state, { clinicSearchResults }) => ({
    ...state,
    clinicsLoading: false,
    clinicSearchResults,
  })),
  on(getClinicsFailure, (state, { error, message }) => ({
    ...state,
    clinicsLoading: false,
    clinicsError: { error, message },
  })),

  on(getClinicDetails, (state) => ({
    ...state,
    clinicDetailsLoading: true,
  })),
  on(getClinicDetailsSuccess, (state, { clinicDetails }) => ({
    ...state,
    clinicDetailsLoading: false,
    clinicDetails,
  })),
  on(getClinicDetailsFailure, (state, { error, message }) => ({
    ...state,
    clinicDetailsLoading: false,
    clinicDetailsError: { error, message },
  })),

  on(getSearchAddress, (state, { searchAddress }) => ({
    ...state,
    searchAddress,
  })),
  on(updateSearchAddress, (state, { searchAddress }) => ({
    ...state,
    searchAddress,
  })),
);

export const reducer = (state: State | undefined, action: Action) =>
  clinicReducer(state, action);
